import React from "react";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Box from "@mui/material/Box";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";

export interface Vehicle {
  id: string;
  licensePlate: string;
  state?: string;
  make?: string;
  model?: string;
}

export interface VehiclesSectionProps {
  vehicles: Vehicle[];
}

export const VehiclesSection: React.FC<VehiclesSectionProps> = ({ vehicles }) => {
  if (vehicles.length === 0) {
    return null;
  }

  return (
    <Paper sx={{ p: { xs: 2, md: 3 }, mb: 3 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Covered Vehicles
      </Typography>
      <List disablePadding sx={{ maxHeight: 300, overflow: "auto" }}>
        {vehicles.map((vehicle) => (
          <ListItem
            key={vehicle.id}
            sx={{
              bgcolor: "action.hover",
              borderRadius: 1,
              mb: 1,
              "&:last-child": { mb: 0 },
            }}
          >
            <ListItemIcon sx={{ minWidth: 40 }}>
              <DirectionsCarIcon color="action" />
            </ListItemIcon>
            <ListItemText
              primary={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography variant="body1" component="span" fontFamily="monospace" fontWeight={500}>
                    {vehicle.licensePlate}
                  </Typography>
                  {vehicle.state && (
                    <Typography variant="body2" component="span" color="text.secondary">
                      ({vehicle.state})
                    </Typography>
                  )}
                </Box>
              }
              secondary={vehicle.make && vehicle.model ? `${vehicle.make} ${vehicle.model}` : undefined}
            />
          </ListItem>
        ))}
      </List>
    </Paper>
  );
};

export default VehiclesSection;
